import {List, Map} from 'immutable';
import defaultFormReducer from '../../defaultFormReducer';
import { formsNames } from '../../../enums/formsNames';
import { actionTypes as actionTypes } from '../../../actions/Administration/MatSettingsPage/qplTestFormActions';

let defaultState = {
  loading: false,
  formData: null,
};

export default function (state = Map(defaultState), action) {
  let newData = {};
  switch (action.type) {
    case actionTypes.QPL_TEST_FORM_FETCH_OPTIONAL_FIELDS_READY:
      newData = {...state.get('formData'),  ...action.payload};
      return state.set('formData', newData);

    default:
      return defaultFormReducer(state, action, formsNames.QPL_TEST_FORM, defaultState);
  }
}
